import React, { useContext } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { WebNotificationType } from 'Shared/constants/types';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { NotificationsContext } from '../../../../NotificationsProviderContext';
import { WpButton } from 'Wpds/components/button';
import { WpLink } from 'Wpds/components/link';

type Props = {
  onCreateActionItemClick: Function;
  notification: {
    users: Array<{
      id: number;
      firstName: string;
      email: string;
    }>;
    data: {
      type: string;
      link: string;
    };
  };
};

function CreateActionItemLinkContent({ onCreateActionItemClick, notification }: Props) {
  const { handleSetIsOpen } = useContext(NotificationsContext);
  const { feedbackActionItem } = useFlags();
  const { id: currentUserId } = useCurrentUser();
  const teammate = notification.users && notification.users.find(({ id }) => id !== currentUserId);

  const handleGiveFeedbackReminderLinkClick = () => {
    handleSetIsOpen(false);
    onCreateActionItemClick({ teammate });
  };

  const handleDraftFeedbackReminderLinkClick = () => {
    handleSetIsOpen(false);
    const title = `Finish giving ${teammate?.firstName || teammate?.email} Feedback`;
    onCreateActionItemClick({ teammate, title });
  };

  switch (notification?.data?.type) {
    case WebNotificationType.giveFeedbackReminder:
      return feedbackActionItem ? (
        <span>
          &nbsp;
          <WpLink href={notification.data?.link} onClick={() => handleSetIsOpen(false)}>
            Give Feedback
          </WpLink>{' '}
          now or&nbsp;
          <WpButton variant="link" onClick={handleGiveFeedbackReminderLinkClick}>
            Create an action item
          </WpButton>
          &nbsp;for later
        </span>
      ) : null;
    case WebNotificationType.draftFeedback:
      return (
        <span>
          &nbsp;
          <WpLink href={notification.data?.link} onClick={() => handleSetIsOpen(false)}>
            Finish Feedback
          </WpLink>{' '}
          now or&nbsp;
          <WpButton variant="link" onClick={handleDraftFeedbackReminderLinkClick}>
            Create an action item
          </WpButton>
          &nbsp;for later.
        </span>
      );
    case WebNotificationType.feedbackRequested:
    case WebNotificationType.feedbackRequestedReminder:
      return (
        <span>
          &nbsp;
          <WpLink href={notification.data?.link} onClick={() => handleSetIsOpen(false)}>
            Give Feedback
          </WpLink>{' '}
          now or&nbsp;
          <WpButton variant="link" onClick={handleGiveFeedbackReminderLinkClick}>
            Create an action item
          </WpButton>
          &nbsp;for later.
        </span>
      );
    default:
      return null;
  }
}

export default CreateActionItemLinkContent;
